export default {"src":"/pro/_next/static/media/sui.e5e65fe2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};